import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'
import ListItemButton from '@mui/material/ListItemButton'
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined'
import themeConfig from '../../../configs/themeConfig'
import Translations from '../Translations'
import { useAuth } from '../../../hooks/useAuth'
import { ListItem, ListItemIcon } from '@mui/material'
import UserIcon from '../UserIcon'
import { useTranslation } from 'react-i18next'
import { axiosInstance } from 'src/network/adapter'
import { ApiEndPoints } from 'src/network/endpoints'
import { toastError, toastSuccess } from 'src/utils/utils'

// ** Styled Components
const MenuNavLink = styled(ListItemButton)(({ theme }) => ({
  width: '100%',
  transition: 'padding-left .25s ease-in-out',
  '& .MuiTypography-root, & .MuiListItemIcon-root': {
    color: `#B83232 !important`
  }
}))

const MenuItemTextMetaWrapper = styled(Box)({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  transition: 'opacity .25s ease-in-out',
  ...(themeConfig.menuTextTruncate && { overflow: 'hidden' })
})

function AfterVerticalNavMenuContent(props) {
  const { t } = useTranslation()

  // ** Hooks
  const auth = useAuth()

  const { settings, navHover, collapsedNavWidth, navigationBorderWidth } = props
  const { navCollapsed } = settings

  return (
    <Box
      className='nav-items'
      sx={{
        transition: 'padding .25s ease',
        '& > :first-of-type': { mt: '0' },
        pr: !navCollapsed || (navCollapsed && navHover) ? 4.5 : 1.25,
        pl: !navCollapsed || (navCollapsed && navHover) ? 4.5 : 1.25,
        pt: !navCollapsed || (navCollapsed && navHover) ? 4.5 : 1.25,
        pb: !navCollapsed || (navCollapsed && navHover) ? 4.5 : 1.25
      }}
    >
      <ListItem disablePadding sx={{ mt: 1.5, px: '0 !important' }}>
        <MenuNavLink
          onClick={e => {
            auth.logout()
          }}
          sx={{
            py: 2.25,
            cursor: 'pointer',
            pl: navCollapsed && !navHover ? (collapsedNavWidth - navigationBorderWidth - 24) / 8 : 5.5,
            pr: navCollapsed && !navHover ? ((collapsedNavWidth - navigationBorderWidth - 24) / 2 - 5) / 4 : 3.5
          }}
        >
          <ListItemIcon
            sx={{
              color: '#B83232',
              transition: 'margin .25s ease-in-out',
              ...(navCollapsed && !navHover ? { mr: 0 } : { mr: 2.5 })
            }}
          >
            <UserIcon
              icon={LogoutOutlinedIcon}
              componentType='vertical-menu'
              iconProps={{
                sx: {
                  fontSize: '1.5rem'
                }
              }}
            />
          </ListItemIcon>

          <MenuItemTextMetaWrapper
            sx={{
              ...(navCollapsed && !navHover ? { opacity: 0 } : { opacity: 1 })
            }}
          >
            <Typography
              sx={{ fontWeight: 700, fontSize: '16px', color: '#B83232' }}
              {...((themeConfig.menuTextTruncate || (!themeConfig.menuTextTruncate && navCollapsed && !navHover)) && {
                noWrap: true
              })}
            >
              {t('Log Out')}
            </Typography>
          </MenuItemTextMetaWrapper>
        </MenuNavLink>
      </ListItem>
    </Box>
  )
}

export default AfterVerticalNavMenuContent
